import { css } from "styled-components";
import { buildRulesets } from "./buildRulesets";
import "../designTokens/variables.css";

const fontFamily = css`
  font-family: "Nunito Sans", "Nunito", var(--font-family-alpha);
`;

const textStyleToSizeMapping = {
  headline1: css`
    font-weight: var(--font-weight-light);
    font-size: 51px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-60);
  `,
  headline2: css`
    font-weight: var(--font-weight-semibold);
    font-size: 26px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-36);
  `,
  headline3: css`
    font-weight: var(--font-weight-regular);
    font-size: 26px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-36);
  `,
  subtitle1: css`
    font-weight: var(--font-weight-semibold);
    font-size: 17px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-24);
  `,
  subtitle2: css`
    font-weight: var(--font-weight-regular);
    font-size: 17px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-24);
  `,
  subtitle3: css`
    font-weight: var(--font-weight-semibold);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-20);
  `,
  body1: css`
    font-weight: var(--font-weight-regular);
    font-size: var(--size-font-base);
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-20);
  `,
  body2: css`
    font-weight: var(--font-weight-extrabold);
    font-size: 13px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-20);
  `,
  body3: css`
    font-weight: var(--font-weight-bold);
    font-size: 13px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-20);
  `,
  body4: css`
    font-weight: var(--font-weight-semibold);
    font-size: 13px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-20);
  `,
  caption: css`
    font-weight: var(--font-weight-bold);
    font-size: 11px;
    letter-spacing: var(--letter-spacing-normal);
    line-height: var(--line-height-14);
  `,
};

const rulesets = buildRulesets({ fontFamily, textStyleToSizeMapping });

export const {
  primaryActive,
  primaryInactive,
  primaryDisabled,
  link,
  warning,
  error,
  success,
  whiteActive,
  whiteInactive,
  whiteDisabled,
} = rulesets;
